import { FieldConfig, useField } from 'formik';
import Password, { PasswordInputProps } from 'mymoria-ui/components/Form/Password';
import React, { ChangeEvent, FunctionComponent, useCallback } from 'react';

const PasswordField: FunctionComponent<Omit<FieldConfig, 'validate'> & PasswordInputProps> = ({
  onChange,
  validation = true,
  ...props
}) => {
  const [field, meta] = useField(props);

  const handleChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      field.onChange(e);
      onChange && onChange(e);
    },
    [field, onChange],
  );

  // if input is prefilled and has no error allow validation other wise check error state
  const prefilled = (field.value && !meta.error) || !!meta.error;

  return (
    <Password
      {...field}
      {...props}
      onChange={handleChange}
      validation={validation && meta.touched && prefilled}
      error={meta.touched ? meta.error : ''}
    />
  );
};

export default PasswordField;
